import { LoanPersonal } from 'src/presentation/pages'

export const makeLoanPersonal = () => <LoanPersonal />
